import { connect } from "react-redux";

import Farmaceuta from "./Farmaceuta";

const mapStatetoProps = state => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(Farmaceuta);
